import React from 'react'
import ColorButtons from "../atoms/ColorButtons";
import {useBoundStore} from '../../stores/useBoundStore';
import styled from 'styled-components';

const Holder = styled.div`
  height: auto;
  width: 100%;
`

const BackgroundControl = () => {
  const setBackground = useBoundStore(state => state.setBackground);
  const handleBackgroundChange = (val, color) => {
    setBackground(color)
  }
  return (
    <Holder>
      <p className="label">Background</p>
      <ColorButtons clickHandler={handleBackgroundChange} />
    </Holder>

  )
}

export default BackgroundControl